import pl from "./languages/pl";
import en from "./languages/en";

export const messages: Record<string, Record<string, string>> = {
  en,
  pl,
};

export const languageList = Object.keys(messages);
export default messages;
